export default "__VITE_ASSET__Dnfia8f$__"